import React from "react";
import EditOrganizationProfile from "./EditOrganizationProfile";
import { useLocation, useHistory } from "react-router-dom";

/**
 * This component is created for full-screen mode and
 * handles both full organization profile updates and
 * updates for specific questions.
 */

export default function EditOrganizationHandler() {
  const location = useLocation();
  const history = useHistory();
  //   const listOfSteps = useSelector((state) => state.organizationProfile.listOfSteps);
  //  const[steId, setStepId] = useState( listOfSteps[0]?.identifier );
  try {
    const { step_id, question_id, stepComleted } = location.state;

    return (
      <EditOrganizationProfile
        step_id={step_id || "7c0a8d2a-3d3a-4216-a01b-071a5139dfd3"}
        question_id={question_id}
        stepComleted={stepComleted}
      />
    );
  } catch (error) {
    history.goBack();
  }
}
